import { THEME_VARIANTS, DEFAULT_COLORS } from './constants';

export const themePresets = {
  // Default light theme
  default: {
    name: 'Default',
    description: 'Clean and modern light theme',
    variant: THEME_VARIANTS.LIGHT,
    customColors: {
      primary: DEFAULT_COLORS.PRIMARY,
      secondary: DEFAULT_COLORS.SECONDARY,
    },
  },

  // Default dark theme
  dark: {
    name: 'Dark',
    description: 'Elegant dark theme for low-light environments',
    variant: THEME_VARIANTS.DARK,
    customColors: {
      primary: DEFAULT_COLORS.PRIMARY,
      secondary: DEFAULT_COLORS.SECONDARY,
    },
  },

  // Pink theme
  pink: {
    name: 'Pink Mode',
    description: 'Special pink theme for unique experiences',
    variant: THEME_VARIANTS.PINK,
    customColors: {
      primary: '#FF1493',
      secondary: '#FF69B4',
    },
  },

  // Blue theme variations
  ocean: {
    name: 'Ocean',
    description: 'Calming blue tones inspired by the ocean',
    variant: THEME_VARIANTS.LIGHT,
    customColors: {
      primary: '#1890FF',
      secondary: '#03A9F4',
    },
  },

  oceanDark: {
    name: 'Ocean Dark',
    description: 'Dark ocean theme with deep blue accents',
    variant: THEME_VARIANTS.DARK,
    customColors: {
      primary: '#1890FF',
      secondary: '#03A9F4',
    },
  },

  // Green theme variations
  forest: {
    name: 'Forest',
    description: 'Natural green theme inspired by forests',
    variant: THEME_VARIANTS.LIGHT,
    customColors: {
      primary: '#52C41A',
      secondary: '#CDDC39',
    },
  },

  forestDark: {
    name: 'Forest Dark',
    description: 'Dark forest theme with natural green accents',
    variant: THEME_VARIANTS.DARK,
    customColors: {
      primary: '#52C41A',
      secondary: '#CDDC39',
    },
  },

  // Purple theme variations
  royal: {
    name: 'Royal',
    description: 'Elegant purple theme with royal vibes',
    variant: THEME_VARIANTS.LIGHT,
    customColors: {
      primary: '#722ED1',
      secondary: '#673AB7',
    },
  },

  royalDark: {
    name: 'Royal Dark',
    description: 'Dark royal theme with deep purple accents',
    variant: THEME_VARIANTS.DARK,
    customColors: {
      primary: '#722ED1',
      secondary: '#673AB7',
    },
  },

  // Orange theme variations
  sunset: {
    name: 'Sunset',
    description: 'Warm orange theme inspired by sunsets',
    variant: THEME_VARIANTS.LIGHT,
    customColors: {
      primary: '#FA8C16',
      secondary: '#FFC107',
    },
  },

  sunsetDark: {
    name: 'Sunset Dark',
    description: 'Dark sunset theme with warm orange accents',
    variant: THEME_VARIANTS.DARK,
    customColors: {
      primary: '#FA8C16',
      secondary: '#FFC107',
    },
  },
};

// Helper function to get preset by name
export const getThemePreset = (presetName) => {
  return themePresets[presetName] || themePresets.default;
};

// Helper function to get all preset names
export const getThemePresetNames = () => {
  return Object.keys(themePresets);
};

// Helper function to get presets by variant
export const getThemePresetsByVariant = (variant) => {
  return Object.entries(themePresets)
    .filter(([, preset]) => preset.variant === variant)
    .reduce((acc, [key, preset]) => {
      acc[key] = preset;
      return acc;
    }, {});
}; 